import '@angular/compiler';
import { PageSettingsAiComponent } from './page.settings.ai/page.settings.ai.component';
import { PageAnalysisDetailComponent } from './page.analysis.detail/page.analysis.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageRequestLinkComponent } from './page.request.link/page.request.link.component';
import { PageCrawlDetailComponent } from './page.crawl.detail/page.crawl.detail.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageScrapComponent } from './page.scrap/page.scrap.component';
import { PagePresentationComponent } from './page.presentation/page.presentation.component';
import { PageProposalComponent } from './page.proposal/page.proposal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageProposalDetailComponent } from './page.proposal.detail/page.proposal.detail.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageCodexComponent } from './page.codex/page.codex.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAssetsComponent } from './page.assets/page.assets.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageCrawlComponent } from './page.crawl/page.crawl.component';
import { PageAnalysisComponent } from './page.analysis/page.analysis.component';
import { PagePresentationDetailComponent } from './page.presentation.detail/page.presentation.detail.component';
import { PageCodexDetailComponent } from './page.codex.detail/page.codex.detail.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutMainComponent,
        "children": [
            {
                "path": "settings/ai",
                component: PageSettingsAiComponent,
                "app_id": "page.settings.ai"
            },
            {
                "path": "analysis/:id",
                component: PageAnalysisDetailComponent,
                "app_id": "page.analysis.detail"
            },
            {
                "path": "request-link",
                component: PageRequestLinkComponent,
                "app_id": "page.request.link"
            },
            {
                "path": "crawl/:id",
                component: PageCrawlDetailComponent,
                "app_id": "page.crawl.detail"
            },
            {
                "path": "scrap",
                component: PageScrapComponent,
                "app_id": "page.scrap"
            },
            {
                "path": "presentation",
                component: PagePresentationComponent,
                "app_id": "page.presentation"
            },
            {
                "path": "proposal",
                component: PageProposalComponent,
                "app_id": "page.proposal"
            },
            {
                "path": "proposal/:id",
                component: PageProposalDetailComponent,
                "app_id": "page.proposal.detail"
            },
            {
                "path": "",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "codex",
                component: PageCodexComponent,
                "app_id": "page.codex"
            },
            {
                "path": "library",
                component: PageAssetsComponent,
                "app_id": "page.assets"
            },
            {
                "path": "crawl",
                component: PageCrawlComponent,
                "app_id": "page.crawl"
            },
            {
                "path": "analysis",
                component: PageAnalysisComponent,
                "app_id": "page.analysis"
            },
            {
                "path": "presentation/:id",
                component: PagePresentationDetailComponent,
                "app_id": "page.presentation.detail"
            },
            {
                "path": "codex/:id",
                component: PageCodexDetailComponent,
                "app_id": "page.codex.detail"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }